import React, { createContext, useState, useContext, useEffect } from 'react';
import { useAuth as useOidcAuth } from 'react-oidc-context';
import { authService } from '../api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const oidcAuth = useOidcAuth();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        setUser(JSON.parse(storedUser));
      }
      // Refresh user data from API
      authService.getCurrentUser()
        .then(res => {
          setUser(res.data);
          localStorage.setItem('user', JSON.stringify(res.data));
        })
        .catch(() => {
          logout();
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const refreshUser = async () => {
    try {
      const res = await authService.getCurrentUser();
      setUser(res.data);
      localStorage.setItem('user', JSON.stringify(res.data));
      return res.data;
    } catch (err) {
      console.error('Failed to refresh user', err);
    }
  };

  const login = async (credentials) => {
    const res = await authService.login(credentials);
    const { access } = res.data;
    localStorage.setItem('token', access);

    // Fetch user data after successful login
    const userRes = await authService.getCurrentUser();
    const userData = userRes.data;

    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
    return userData;
  };

  const loginWithCognito = async (idToken) => {
    const res = await authService.cognitoLogin(idToken);
    const { access, user: userData } = res.data;
    localStorage.setItem('token', access);
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
    return userData;
  };

  const logout = async () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    sessionStorage.removeItem('postLoginNext');
    // Clear Cognito/OIDC session so Login does not auto sign-in again
    try {
      if (oidcAuth?.removeUser) {
        await oidcAuth.removeUser();
      }
    } catch (err) {
      console.error('Failed to clear Cognito session on logout', err);
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, loginWithCognito, logout, refreshUser, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  );
};


export const useAuth = () => useContext(AuthContext);
